<template>
    <section id="gestao-certificacao">
        <BaseHeader
            :titulo="$tc('certification.messages.title')"
            icon="mdi mdi-file-plus"
            :btnTexto="$tc('certification.messages.new_analysis')"
            :exibeBotao="true"
            @btnHeaderClicado="novaAnalise"
        />

        <div class="view-container-base-header">
            <div class="bloco-infor-dados">
                <div class="item-container">
                    <SkeletonBlocoInformacao>
                        <BlocoInformacao
                            class="bloco-informacao"
                            :titulo="$tc('certification.words.territory', 2)"
                            :subtitulo="$tc('certification.words.analyzed', 2)"
                            :numero="totalizadores.territoriosAnalisados"
                            :class="[
                                tagsFiltro.includes('Territórios analisados')
                                    ? 'bloco-infor-dados-ativo'
                                    : ''
                            ]"
                        />
                    </SkeletonBlocoInformacao>
                </div>

                <div class="item-container" @click="setFiltro('AREA', 1)">
                    <SkeletonBlocoInformacao>
                        <BlocoInformacao
                            class="bloco-informacao"
                            :titulo="$tc('certification.words.planting_area')"
                            :subtitulo="`${$tc(
                                'certification.words.eligible'
                            )} (ha)`"
                            sigla="(ha)"
                            :numero="
                                totalizadores.areaPlantioCertificavel &&
                                formatNumber(
                                    totalizadores.areaPlantioCertificavel
                                )
                            "
                            :class="[
                                tagsFiltro.includes('Área plantio elegível')
                                    ? 'bloco-infor-dados-ativo'
                                    : ''
                            ]"
                        />
                    </SkeletonBlocoInformacao>
                </div>

                <div class="item-container" @click="setFiltro('2BSvs', 2)">
                    <SkeletonBlocoInformacao>
                        <BlocoInformacao
                            class="bloco-informacao"
                            :titulo="$tc('certification.words.territory', 2)"
                            :subtitulo="`${$tc(
                                'certification.words.eligible',
                                2
                            )} 2BSvs`"
                            :numero="totalizadores.territorios2BSvs"
                            :class="[
                                tagsFiltro.includes('2BSvs: Elegível')
                                    ? 'bloco-infor-dados-ativo'
                                    : ''
                            ]"
                        />
                    </SkeletonBlocoInformacao>
                </div>

                <div class="item-container" @click="setFiltro('RTRS', 3)">
                    <SkeletonBlocoInformacao>
                        <BlocoInformacao
                            class="bloco-informacao"
                            :titulo="$tc('certification.words.territory', 2)"
                            :subtitulo="`${$tc(
                                'certification.words.eligible',
                                2
                            )} RTRS`"
                            :numero="totalizadores.territoriosRTRS"
                            :class="[
                                tagsFiltro.includes('RTRS: Elegível')
                                    ? 'bloco-infor-dados-ativo'
                                    : ''
                            ]"
                        />
                    </SkeletonBlocoInformacao>
                </div>

                <div class="item-container" @click="setFiltro('Proterra', 4)">
                    <SkeletonBlocoInformacao>
                        <BlocoInformacao
                            class="bloco-informacao"
                            :titulo="$tc('certification.words.territory', 2)"
                            :subtitulo="`${$tc(
                                'certification.words.eligible',
                                2
                            )} Proterra`"
                            :numero="totalizadores.territoriosProTerra"
                            :class="[
                                tagsFiltro.includes('Proterra: Elegível')
                                    ? 'bloco-infor-dados-ativo'
                                    : ''
                            ]"
                        />
                    </SkeletonBlocoInformacao>
                </div>

                <div class="item-container" @click="setFiltro('EPA', 5)">
                    <SkeletonBlocoInformacao>
                        <BlocoInformacao
                            class="bloco-informacao"
                            :titulo="$tc('certification.words.territory', 2)"
                            :subtitulo="`${$tc(
                                'certification.words.eligible',
                                2
                            )} EPA`"
                            :numero="totalizadores.territoriosEPA"
                            :class="[
                                tagsFiltro.includes('EPA: Elegível')
                                    ? 'bloco-infor-dados-ativo'
                                    : ''
                            ]"
                        />
                    </SkeletonBlocoInformacao>
                </div>
            </div>

            <div class="bloco-pesquisa-filtros">
                <BlocoPesquisaFiltros
                    @emitFiltros="adicionarFiltros"
                    @emitFiltroTotalizador="adicionarFiltros"
                    ref="aplicarFiltroTotalizador"
                />
            </div>

            <div class="bloco-novos-contratos-tabela">
                <TabelaGestaoCertificacao
                    :tabelaData="certificacoesTabela"
                    :carregando="carregandoTabela"
                    :paginacao="paginacao"
                    @mudarPagina="mudarPagina"
                    @ordenarTabela="ordenarTabela"
                    @atualizarTabela="buscarCertificacoes"
                    @handleModalGerarAnalise="handleModalGerarAnalise"
                    :btnRecarregar="true"
                />
            </div>

            <ModalGerarAnalise
                v-if="rowInfo"
                :show.sync="showModalGerarAnalise"
                :rowInfo="rowInfo"
                :checked="checkedValues"
                @atualizarTabela="buscarCertificacoes"
            />
        </div>
    </section>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';

import BlocoInformacao from '@/modules/certification/views/pages/main/components/BlocoInformacaoCertificacao.vue';
import ModalGerarAnalise from '@/modules/certification/views/pages/main/components/ModalGerarAnalise.vue';
import SkeletonBlocoInformacao from '@/modules/certification/views/pages/main/components/BlocoSkeletonInformacaoCertificacao.vue';
import BlocoPesquisaFiltros from '@/modules/certification/views/pages/main/components/PesquisaFiltroCertificacao.vue';
import TabelaGestaoCertificacao from '@/modules/certification/views/pages/main/components/tabela-gestao-certificacao/TabelaGestaoCertificacao.vue';
import CertificacaoService from '@/services/CertificacaoService.js';

import formatters from '@/utils/formatters';

import { mapActions } from 'vuex';

export default {
    name: 'GestaoCertificacao',
    components: {
        BaseHeader,
        BlocoInformacao,
        SkeletonBlocoInformacao,
        BlocoPesquisaFiltros,
        TabelaGestaoCertificacao,
        ModalGerarAnalise
    },
    data() {
        return {
            numero: [750, 12.124, 634, 234, 235, 532],
            carregandoTabela: false,
            showModalGerarAnalise: false,
            rowInfo: null,
            checkedValues: [],
            params: {
                page: 0,
                size: 10,
                sort: 'dataCadastro',
                por: 'desc'
            },
            paginacao: {},
            certificacoesTabela: [],
            totalizadores: {
                areaPlantioCertificavel: 0,
                territoriosAnalisados: '',
                territorios2BSvs: '',
                territoriosEPA: '',
                territoriosProTerra: '',
                territoriosRTRS: ''
            },
            filtro: {
                pesquisaFiltro: '',
                estadoId: [],
                territoriosAnalisados: false,
                areaPlantadaElegivel: false
            },
            codigosTotalizadores: [
                {
                    codigoAtivo: false,
                    tag: 'Territórios analisados'
                },
                {
                    codigoAtivo: false,
                    tag: 'Área plantio elegível'
                },
                { codigoAtivo: false, tag: '2BSvs: Elegível' },
                { codigoAtivo: false, tag: 'RTRS: Elegível' },
                { codigoAtivo: false, tag: 'Proterra: Elegível' },
                { codigoAtivo: false, tag: 'EPA: Elegível' }
            ],
            tagsFiltro: []
        };
    },
    mounted() {
        this.buscarTotalizadoresCertificacoes();
        this.buscarCertificacoes();
    },
    methods: {
        ...mapActions('analyzeDeforestationStore', [
            'detail',
            'downloadReport'
        ]),

        novaAnalise() {
            this.$router.push({ name: 'CadastrarCertificacao' });
        },

        handleModalGerarAnalise(rowInfo) {
            if (rowInfo) {
                this.rowInfo = rowInfo;
                if (this.rowInfo.certificacoes) {
                    this.checkedValues = this.rowInfo.certificacoes
                        .filter(
                            cert => cert.status != null && cert.status === true
                        )
                        .map(item => item.status);
                }
                this.showModalGerarAnalise = !this.showModalGerarAnalise;
            }
        },

        async buscarCertificacoes() {
            this.carregandoTabela = true;

            try {
                const { data } =
                    await CertificacaoService.buscarCertificacoesV2(
                        this.filtro,
                        this.params
                    );

                this.certificacoesTabela = data.itens;

                this.paginacao = data.paginacao;
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.territories_fetch_error'
                    )
                });
            }
            this.carregandoTabela = false;
        },

        async buscarTotalizadoresCertificacoes() {
            try {
                const { data } =
                    await CertificacaoService.buscarTotalizadoresCertificacao();
                const itens = data.itens;

                itens.map(territoriosElegiveis => {
                    switch (territoriosElegiveis.tipo) {
                        case 'EPA':
                            this.totalizadores.territoriosEPA =
                                territoriosElegiveis.quantidade;
                            break;

                        case 'RTRS':
                            this.totalizadores.territoriosRTRS =
                                territoriosElegiveis.quantidade;
                            break;

                        case '2BSvs':
                            this.totalizadores.territorios2BSvs =
                                territoriosElegiveis.quantidade;
                            break;

                        case 'Proterra':
                            this.totalizadores.territoriosProTerra =
                                territoriosElegiveis.quantidade;
                            break;

                        default:
                            break;
                    }
                });

                this.totalizadores.areaPlantioCertificavel =
                    data.areaPlantioCertificavel;
                this.totalizadores.territoriosAnalisados =
                    data.territoriosAnalisados;
            } catch (error) {
                this.$notify.error({
                    message: this.$tc(
                        'certification.messages.errors.totals_fetch_error'
                    )
                });
            }
        },

        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },

        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarCertificacoes();
        },
        ordenarTabela(column) {
            if (column.prop === 'nomeTerritorio') {
                this.params.sort = 'geoRel.nomeTerritorio';
            } else {
                this.params.sort = column.prop;
            }
            if (column.prop === 'areaPlantadaHa') {
                this.params.sort = 'geoRel.areaPlantadaHa';
            }

            if (column.order === 'ascending') {
                this.params.por = 'asc';
            } else if (column.order === 'descending') {
                this.params.por = 'desc';
            }
            this.buscarCertificacoes();
        },
        adicionarFiltros(filtro, tags) {
            if (tags && tags.length) {
                this.tagsFiltro = [];

                tags.forEach(item => {
                    if (typeof item === 'string') {
                        if (!this.tagsFiltro.includes(item)) {
                            this.tagsFiltro.push(item);
                        }
                    } else if (typeof item === 'object' && item.nome) {
                        if (!this.tagsFiltro.includes(item.nome)) {
                            this.tagsFiltro.push(item.nome);
                        }
                    }
                });
            } else {
                this.tagsFiltro = [];
            }

            // Verifica quais tags dos totalizadores estão ativas e
            // indica se o totalizador está ou não selecionado.
            this.codigosTotalizadores.forEach(totalizador => {
                const tagPresente = this.tagsFiltro.includes(totalizador.tag);
                if (!tagPresente) {
                    totalizador.codigoAtivo = false;
                }
            });
            if (filtro.certificacaoTipoStatus) {
                if (Object.keys(filtro.certificacaoTipoStatus).length > 0) {
                    this.certificacoesComoObjeto(filtro.certificacaoTipoStatus);
                } else {
                    this.filtro.certificacaoTipoStatus = {};
                    let codigosTotalizadores = [
                        {
                            codigoAtivo:
                                this.codigosTotalizadores[0].codigoAtivo,
                            tag: 'Territórios analisados'
                        },
                        {
                            codigoAtivo:
                                this.codigosTotalizadores[1].codigoAtivo,
                            tag: 'Área plantio elegível'
                        },
                        { codigoAtivo: false, tag: '2BSvs: Elegível' },
                        { codigoAtivo: false, tag: 'RTRS: Elegível' },
                        {
                            codigoAtivo: false,
                            tag: 'Proterra: Elegível'
                        },
                        { codigoAtivo: false, tag: 'EPA: Elegível' }
                    ];

                    this.codigosTotalizadores = codigosTotalizadores;
                }
            }

            if (tags.includes('Territórios analisados')) {
                this.filtro.territoriosAnalisados = true;
            } else {
                this.filtro.territoriosAnalisados = false;
            }

            if (tags.includes('Área plantio elegível')) {
                this.filtro.areaPlantadaElegivel = true;
            } else {
                this.filtro.areaPlantadaElegivel = false;
            }

            this.filtro.pesquisaFiltro = filtro.pesquisa || '';
            this.filtro.estadoId = filtro.estadoSelecionado || '';
            this.params.page = 0;

            this.buscarCertificacoes();
        },

        setFiltro(dado, indice) {
            this.codigosTotalizadores[indice].codigoAtivo =
                !this.codigosTotalizadores[indice].codigoAtivo;

            if (this.codigosTotalizadores[indice].codigoAtivo) {
                this.$refs.aplicarFiltroTotalizador.inserirFiltroTotalizador(
                    dado
                );
            } else {
                this.$refs.aplicarFiltroTotalizador.removerFiltro(dado);
            }
        },

        certificacoesComoObjeto(filtroCertificacaoTipoStatus) {
            let certificacoesComoObjeto = {};

            if (filtroCertificacaoTipoStatus) {
                Object.keys(filtroCertificacaoTipoStatus).forEach(function (
                    key
                ) {
                    certificacoesComoObjeto[key] =
                        filtroCertificacaoTipoStatus[key];
                });
            }
            this.filtro.certificacaoTipoStatus = certificacoesComoObjeto;
        }
    }
};
</script>

<style lang="scss" scoped>
#gestao-certificacao {
    .bloco-infor-dados {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
        flex-wrap: wrap;

        & > div {
            flex-grow: 1;
        }

        #certificacao-bloco-informacoes {
            cursor: pointer;
        }
    }

    .bloco-infor-dados,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }

    .secao-listagem-filtro-sub-empresa {
        display: flex;
        margin-top: 25px;
        justify-content: space-between;

        .el-checkbox__label,
        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .bloco-informacao {
        cursor: pointer;
    }

    #certificacao-bloco-informacao {
        border: 1px solid #e1e1e1;

        &.bloco-infor-dados-ativo {
            border-color: var(--primary) !important;
        }
    }
}

@media only screen and (max-width: 1200px) {
    .bloco-infor-dados > div {
        width: 32%;
    }
}
</style>
